import { combineReducers } from "redux";
import { postReducer } from "./posts";
import { authReducer } from "./auth"
import { commentReducer } from "./comments";
export default combineReducers({
    postReducer,
    authReducer,
    comment: commentReducer
})